import { getErrorMessage, getToken } from '../../../../utils/common';
import { postV1WarehouseLocation, postV1InventoryFixedAssetItems, postV1CategoryItems, postV1Brand } from '../../../../api-client/api.inventory/api';
import { PostV1WarehouseLocationRequest } from '../../../../api-client/api.inventory/api-types';
import { enqueueSnackbar } from 'notistack';
import { postV1Parties, postV1PartiesIndustry, postV1JournalTypes, postV1PaymentTerms } from '../../../../api-client/api.accounting/api';
import { postV1Teams, postV1Designation, postV1Departments, postV1DepartmentsTeams } from '../../../../api-client/api.hrms/api';
import { postV1SourceTypes } from '../../../../api-client/api.sales/api';
import CustomerVendorModal from '@/components/parties-modal';
import { TeamAddModal } from '../../../team-add-modal';
import { DepartmentAddModal } from '@/components/department-add-modal';
import { LocationAddModal } from './location-add-modal';
import { DesignationAddModal } from '@/components/designation-add-modal';
import { FixedAssetItemAddModal } from './fixed-asset-item-add-modal';
import { DialogProps } from '@mui/material';
import { BrandAddModal } from '@/components/brand-add-modal';
import { CategoryAddModal } from '@/components/category-add-modal';
import { IndustryAddModal } from '@/components/industry-add-modal';
import { SourceTypeAddModal } from '@/components/source-type-add-modal/source-type-add-modal';
import { JournalTypeAddModal } from '@/components/journal-type-add-modal';
import { PaymentTermAddModal } from '@/components/payment-term-add-modal';

export const createApiThunk = async (api: (payload: any) => Promise<any>, payload: any) => {
	try {
		return await api({ ...payload, ...getToken() })
	} catch (error) {
		try {
			enqueueSnackbar(getErrorMessage(error?.message), { variant: 'error' });
		} catch {
			console.error('[createApiThunk] enqueueSnackbar not available:', getErrorMessage(error?.message));
		}
		throw error;
	}
}

export interface IAddConfig {
	api: (payload: any) => Promise<any>;
	component: any;
}

export interface IModalComponentProps {
	isOpen: boolean;
	setIsOpen: () => void;
	modalProps?: DialogProps;
	onSave: (data: string) => void;
	isLoading?: boolean;
}

const addMapper: Record<string, IAddConfig> = {
	location: {
		api: (payload: PostV1WarehouseLocationRequest) => createApiThunk(postV1WarehouseLocation, payload),
		component: LocationAddModal,
	},
	party: {
		api: (payload: any) => createApiThunk(postV1Parties, payload),
		component: CustomerVendorModal,
	},
	department: {
		api: (payload: any) => createApiThunk(postV1Departments, payload),
		component: DepartmentAddModal,
	},
	team: {
		api: (payload: any) => createApiThunk(postV1DepartmentsTeams, payload),
		component: TeamAddModal,
	},
	designation: {
		api: (payload: any) => createApiThunk(postV1Designation, payload),
		component: DesignationAddModal,
	},
	fixedAssetItem: {
		api: (payload: any) => createApiThunk(postV1InventoryFixedAssetItems, payload),
		component: FixedAssetItemAddModal,
	},
	brand: {
		api: (payload: any) => createApiThunk(postV1Brand, payload),
		component: BrandAddModal,
	},
	category: {
		api: (payload: any) => createApiThunk(postV1CategoryItems, payload),
		component: CategoryAddModal,
	},
	industry: {
		api: (payload: any) => createApiThunk(postV1PartiesIndustry, payload),
		component: IndustryAddModal,
	},
	sourceType: {
		api: (payload: any) => createApiThunk(postV1SourceTypes, payload),
		component: SourceTypeAddModal,
	},
	journalType: {
		api: (payload: any) => createApiThunk(postV1JournalTypes, payload),
		component: JournalTypeAddModal,
	},
	journal_type: {
		api: (payload: any) => createApiThunk(postV1JournalTypes, payload),
		component: JournalTypeAddModal,
	},
	paymentTerm: {
		api: (payload: any) => createApiThunk(postV1PaymentTerms, payload),
		component: PaymentTermAddModal,
	},
};

export const dynamicSelectAdd = (addType: string): IAddConfig | null => {
	const config = addMapper[addType];

	if (!config) {
		console.warn(`No configuration found for addType: ${addType}`);
		return null;
	}

	return {
		...config
	};
};
